import { KontentImage } from '@components/gassan-ui/Image/KontentImage'
import { cn } from '@lib/cn'
import { FC } from 'react'

type Props = {
  src: string
  alt: string
}

const FeaturedImage: FC<Props> = ({ src, alt }) => {
  return (
    <div
      className={cn(
        'mt-0 flex w-full max-w-none justify-center',
        'sm:mx-auto sm:mt-14',
        'md:mt-[4.5rem] md:landscape:max-h-[70vh] md:landscape:overflow-hidden',
        'lg:mt-0 lg:max-w-[44rem]',
      )}
    >
      <KontentImage className={cn('aspect-[2/1]', 'md:aspect-[10/7]')} src={src} alt={alt} />
    </div>
  )
}

export default FeaturedImage
